'use strict';
module.exports = function freemindImport(xml) {

	const parser = new DOMParser(),
		nodeStyle = function (xmlNode, parentStyle) {
			const style = {},
				richContentChild =  Array.from(xmlNode.children).find(t => t.matches('richcontent')),
				attachment = richContentChild && richContentChild.querySelector('body');

			if (xmlNode.getAttribute('BACKGROUND_COLOR')) {
				style.style = {background: xmlNode.getAttribute('BACKGROUND_COLOR')};
			}
			if ((parentStyle && parentStyle.collapsed) || xmlNode.getAttribute('FOLDED') === 'true') {
				style.collapsed = 'true';
			}
			if (attachment) {
				style.attachment = { contentType: 'text/html', content: attachment.innerHTML };
			}
			return style;
		},
		xmlToJson = function (xmlNode, parentStyle) {
			const result = {'title': xmlNode.getAttribute('TEXT') || ''},
				childNodes = Array.from(xmlNode.children).filter(t => t.matches('node')),
				style = nodeStyle(xmlNode, parentStyle),
				children = childNodes.map(function (child) {
					return xmlToJson(child, style);
				}),
				childObj = {};
			if (Object.keys(style).length) {
				result.attr = style;
			}
			if (children.length > 0) {
				children.forEach((child, index) => {
					const position = childNodes[index].getAttribute('POSITION') === 'left' ? -1 : 1,
						rank = position * (index + 1);
					childObj[rank] = child;
				});
				result.ideas = childObj;
			} else if (result.attr && result.attr.collapsed) {
				delete result.attr.collapsed;
			}
			return result;
		},
		xmlDoc = parser.parseFromString(xml, 'text/xml'),
		firstNode = xmlDoc.querySelector('map > node'),
		result = xmlToJson(firstNode);
	result.formatVersion = 2;
	return result;
};
